import * as ko from "knockout";
import {IButton, IRouteDefinition, TBaseOrObservableType, TRouteId} from "../../index";
import {getEadmRole, isNullOrUndefined} from "../../util/misc";
import {TabManager} from "./TabManager";
import {global} from "../../appContext";
import {ErrorManager} from "../../error/ErrorManager";
import {ButtonManager} from "../../util/ButtonManager";
import {nsBadge} from "../../util/badge";
import TBadgeValue = nsBadge.TBadgeValue;
import TBadgeObject = nsBadge.TBadgeObject;
import {nsRoute} from "../../util/route";

export class Tab {
    private _isVisible: KnockoutObservable<boolean | (() => boolean)> = ko.observable<boolean | (() => boolean)>(true);
    private onClick: (id: TRouteId) => void;
    public badge: KnockoutObservable<TBadgeValue | TBadgeObject | null> = ko.observable(null);
    public id: TRouteId;
    public isWaiting: KnockoutObservable<boolean> = ko.observable(false);
    public errorManager: ErrorManager = new ErrorManager();
    private buttonManager: ButtonManager = new ButtonManager()
    public show: KnockoutObservable<boolean | (() => boolean)> = ko.observable<boolean | (() => boolean)>(true)

    public isPermissible: KnockoutComputed<boolean>;
    public isVisible: KnockoutComputed<boolean>;

    constructor(private __tabManager: TabManager, public __routeDef: IRouteDefinition) {
        this.id = __routeDef.id;
        this.onClick = __tabManager.onClick.bind(__tabManager, this.id);

        this.isPermissible = ko.pureComputed((): boolean => {
            const user = global.login.user();
            const currentRoute = global.router.currentRoute();
            if (!currentRoute) {
                return false;
            }
            const eAdmRole = getEadmRole();
            if (this.__routeDef.canSeeOwnPage && user?.id == currentRoute.__id) {
                return true;
            }
            const org = global.login.selectedOrganization();
            if (!org) {
                return false;
            }
            const isLisenceOkay = nsRoute.isRouteLicenseOkay(this.__routeDef, org)
            if (!isLisenceOkay) {
                return false
            }

            const permissionLevel = this.__routeDef.permissionLevel ?? 0;
            return eAdmRole >= permissionLevel;
        });

        this.isVisible = ko.computed({
            read: () => {
                if (!this.show()) {
                    return false
                }
                if (!this.isPermissible()) {
                    return false;
                }
                if (typeof this._isVisible() === 'function') {
                    const fn = this._isVisible() as () => any;
                    return fn();
                }
                return this._isVisible();
            },
            write: (val: any) => {
                this._isVisible(val);
            },
        });
    }

    public isCurrent(): boolean {
        return this.__tabManager.currentId() == this.id;
    }

    private getBadge(): string | null {
        const badge = this.badge();
        if (isNullOrUndefined(badge)) {
            return null;
        }
        if (typeof badge === 'string' && badge.startsWith('<')) {
            return badge;
        }
        const value = nsBadge.getValue(this.badge as KnockoutObservable<TBadgeValue | TBadgeObject | null>);
        return value == null || value === '' ? null : String(value);
    }

    public addButton(btn: TBaseOrObservableType<IButton>) {
        this.buttonManager.add(btn)
    }

    public getContentComponent() {
        return this.__routeDef.component;
    }

}